/** Asset/link path with CRA PUBLIC_URL prefix (e.g. /tippspiel in production). */
export function publicUrl(path) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
